import { Spinner } from "spin.js";
import $ from "jquery";
import { v4 as uuid } from "uuid";

const allLoaders = new WeakMap();

const getDomEl = (obj) => {
    if (obj instanceof $) {
        return obj[0];
    }
    return obj;
};

export class Loader {
    constructor(opts) {
        this.spinner = new Spinner({
            lines: 11, // The number of lines to draw
            length: 6, // The length of each line
            width: 2, // The line thickness
            radius: 7, // The radius of the inner circle
            corners: 1, // Corner roundness (0..1)
            rotate: 0, // The rotation offset
            direction: 1, // 1: clockwise, -1: counterclockwise
            color: "#000", // #rgb or #rrggbb or array of colors
            speed: 1, // Rounds per second
            shadow: false, // Whether to render a shadow
            className: "spinner", // The CSS class to assign to the spinner
            zIndex: 200,
            top: "50%", // Top position relative to parent
            left: "50%", // Left position relative to parent
            ...opts
        });
        
        this.id = uuid();
    }
    
    add(target) {
        target = getDomEl(target);
        
        this.target = target;
        this.spinner.spin(target);
        
        // Store a reference
        allLoaders.set(target, this);
        
        this.created = Date.now();
    
        // Schedule a check after 10 seconds to remove a spinner if it's still active, but parent node is disconnected
        this.scheduleRemoval();
    }
    
    scheduleRemoval() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            // Remove the loader if it's parent is not attached to the DOM or it's been more than 2 minutes
            if (document.body.contains(this.target) && Date.now() < this.created + Loader.lifetime) {
                this.scheduleRemoval();
            } else {
                this.remove();
            }
        }, 10_000);
    }
    
    remove() {
        this.spinner.stop();
        
        // Nullify loader's pointer
        allLoaders.delete(this.target);
    
        // Delete the loader itself
        delete this.spinner;
    
        // Delete target reference to avoid memory leaks
        delete this.target;
    
        // Remove a timer
        if (this.timer) {
            clearTimeout(this.timer);
            delete this.timer;
        }
    }
    
    static get lifetime() {
        return 2 * 60 * 1000;
    }
    
    static bulkAction(target, action) {
        if (target === void 0) {
            // No DOM instance to attach the loader
            return;
        }
        if (target.each) {
            target.each(action);
        } else {
            action(null, target);
        }
    }
    
    static removeFrom(target) {
        Loader.bulkAction(target, (i, t) => {
            const _target = getDomEl(t);
            if (allLoaders.has(_target)) {
                allLoaders.get(_target).remove();
            }
        });
    }
    
    static addTo(target, opts = {}) {
        Loader.bulkAction(target, (i, t) => {
            // Don't add another loader if the element already contains one
            const _target = getDomEl(t);
            if (!allLoaders.has(_target)) {
                let options = { ...opts };
    
                try {
                    options = JSON.parse(_target.dataset.loaderOptions);
                } catch {
                    // Nothing here
                }
    
                const loader = new Loader(options);
                loader.add(_target);
            }
        });
    }
}
